import { COLORS } from '@btime/constants'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useCurrentModal } from '../../../components/modals/ModalsContext'
import { useOpenEditTemplatesModal } from '../../../utils/routes/modals/modalsActions'
import Button from '../../../packages/kiti/components/actions/Button'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('templates')
  const openEditModal = useOpenEditTemplatesModal()
  const { data: entity } = useCurrentModal()
  const canCreate = useSessionPermission('createTemplate')

  return (
    <>
      <Grid justify="flex-start" align="center" gutter={0.3}>
        <Col flex={1}>
          <Title size="h4" color={COLORS.dark2} noMargin>
            {t('listTitle')}
          </Title>
        </Col>

        <Col flex={1}></Col>

        {canCreate && (
          <Col>
            <Button transparent onClick={() => openEditModal({ entity })} size="small">
              {t('addNewButton')}
            </Button>
          </Col>
        )}
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
